import { updateUsers } from '../api/updateUsers';
import { setGetMailingUsers } from './setGetMailingUsers';

export const setUpdateUsers = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await updateUsers(params);
            alert('Сохранено');

            if (callback) {
                callback();
            }

            dispatch(setGetMailingUsers({
                id: params.mailing_id,
                page: 1,
                pageSize: 25
            }));
        } catch (error) {
            alert(error?.response?.data?.message)
            console.log(error)
        }
    }
}